import type { CSSProperties } from 'react';

/**
 * Lanuq's wordmark (owner's logo, 2026-11-03): "lanuq." in Geist 800 with tight tracking, the
 * full stop in orange, as in the logo. Our green on light backgrounds, white on dark. Clinic
 * surfaces show each clinic's own name instead.
 */
export function Logo({size=22,inverse=false,mark=true,style={}}:{size?:number;inverse?:boolean;mark?:boolean;style?:CSSProperties}) {
 return (
  <span
   className={inverse ? 'text-white' : 'text-medlux'}
   style={{fontFamily:"'Geist', var(--font-sans), sans-serif",fontWeight:800,letterSpacing:'-0.075em',lineHeight:1,fontSize:size,...style}}
   aria-label="Lanuq"
  >
   {mark ? 'lanuq' : 'l'}
   <span aria-hidden="true" className="text-brand-lanuq">.</span>
  </span>
 );
}
